<template>
	<div class="mt-4">
		<vs-sidebar
			parent="body"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-new-data-sidebar items-no-padding"
			v-model="isSidebarEditActive"
		>
			<div v-if="isSidebarEditActive" class="flex items-center justify-between px-6 p-4" style="background: #eee">
				<h4>{{ $t("Vehicles.UpdateVehicle") + validateIdentification }}</h4>
				<feather-icon
					icon="XIcon"
					class="cursor-pointer"
					@click.stop="isSidebarEditActive = false"
				></feather-icon>
			</div>
			<resource-update
				v-if="isSidebarEditActive"
				:data="resourceObject"
				@closeSidebarEmit="closeSidebarEdit()"
				@vehicleList="getDataVehicles"
			/>
		</vs-sidebar>
		<vs-collapse v-if="resourceList.length > 0" id="VehicleItemDelivery" type="border" :key="renderComponent">
			<vs-collapse-item v-for="(key, indexKey) in resourceList" :key="indexKey" :open="isExpanded">
				<div slot="header">
					{{ key[0] === "undefined" || key[0] === "null" || key[0] === "" ? $t("NoGroupAssigned") : key[0] }}
				</div>
				<vue-perfect-scrollbar :class="key[1].length >= 9 ? 'scroll-area' : ''" :settings="settings">
					<vs-list v-for="(resource, index) in key[1]" :key="index">
						<vs-list-item
							:title="resource.identification"
							:subtitle="resource.profile"
							:class="{'text-danger': showErrorOptimization(resource)}"
						>
							<template slot="avatar">
								<vs-checkbox
									v-if="componentParent === 'GENERATE_REPEAT_VEHICLE'"
									color="success"
									v-model="resource.checked"
								></vs-checkbox>
							</template>
							<div class="vx-row">
								<div v-if="showActions" class="vx-col w-full">
									<div class="mt-2 flex flex-wrap items-center justify-end">
										<feather-icon
											icon="EditIcon"
											svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
											:title="
												showErrorOptimization(resource)
													? $t('ManualData.FixErrorsHere')
													: $t('Edit')
											"
											@click.prevent="editRecord(resource, indexKey)"
										/>
										<feather-icon
											icon="Trash2Icon"
											svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
											:title="$t('Crud.Delete')"
											@click.prevent="removeAssignedResource(resource, indexKey)"
										/>
									</div>
								</div>
								<div v-if="componentParent === 'GENERATE_REPEAT_VEHICLE'" class="vx-col w-full">
									<div class="flex flex-wrap items-center justify-end">
										<feather-icon
											v-if="
												resource.hasOwnProperty('cron') &&
												resource.hasOwnProperty('time_window_repeat')
											"
											icon="EyeIcon"
											svgClasses="h-6 w-6 mr-2 hover:text-primary cursor-pointer"
											:title="$t('ViewRepetitionFormatAndTimeWindow')"
											@click.prevent="activeSidebarDetailRepeat()"
										/>
										<feather-icon
											v-else
											icon="PlusSquareIcon"
											svgClasses="h-6 w-6 mr-2 hover:text-primary cursor-pointer"
											:title="$t('AddRepeatFormatAndTimeWindow')"
											@click.prevent="activeSidebarRepeat(resource)"
										/>
									</div>
								</div>
							</div>
						</vs-list-item>
					</vs-list>
				</vue-perfect-scrollbar>
			</vs-collapse-item>
		</vs-collapse>
		<p class="mt-10 text-center font-semibold text-secondary" v-else>
			{{ textSearch(searchQueryVehicle ? "search" : "") }}
		</p>
	</div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import ResourceUpdate from "@/components/optimization/resource/edit/ResourceUpdate.vue";

export default {
	name: "ListSelectedVisitPointsItemPickup",
	components: {
		vSelect,
		flatPickr,
		VuePerfectScrollbar,
		ResourceUpdate,
	},
	props: {
		resourceList: {
			type: Array,
			default: () => [],
		},
		searchQueryVehicle: {
			type: String,
			default: "",
		},
		showActions: {
			type: Boolean,
			default: true,
		},
		componentParent: {
			type: String,
			default: "VEHICLE_LIST",
		},
	},
	data() {
		return {
			isSidebarEditActive: false,
			resourceObject: null,
			isExpanded: false,
			renderComponent: 0,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	computed: {
		visitPoint() {
			return this.visit_point_selected === undefined ||
				this.visit_point_selected === "" ||
				this.visit_point_selected === null
				? []
				: this.visit_point_selected;
		},
		validateProperty() {
			return function (obj, propertyName) {
				if (Object.hasOwnProperty.call(obj, propertyName)) {
					return obj[propertyName];
				} else {
					return "";
				}
			};
		},
		validateIdentification() {
			return this.visitPoint.hasOwnProperty("identification") &&
				(this.visitPoint.identification != undefined ||
					this.visitPoint.identification != null ||
					this.visitPoint.identification != "")
				? `(${this.visitPoint.identification})`
				: "";
		},
		showErrorOptimization() {
			return (resource) => {
				const errorFilter = this.$store.state.moduleOptimization.errorList.filter((data) => {
					return data.absolute_path[0] == "vehicles" && data.absolute_path[1] === resource.indexResource;
				});
				return errorFilter.length > 0;
			};
		},
		textSearch() {
			return (type) => {
				if (type === "search") return this.$t("NoResultsWereFoundForYourSearch");
				return this.$t("ThereIsNoDataToDisplayPleaseTryToAddNewRecords");
			};
		},
	},
	methods: {
		removeAssignedResource(resource, index) {
			this.$store.commit("moduleOptimization/DELETE_VEHICLE_SELECTED_STANDARD_INPUT", {
				resource,
				indexResource: index,
			});
		},
		closeSidebarEdit() {
			this.isSidebarEditActive = false;
		},
		editRecord(resource, index) {
			this.resourceObject = resource;
			this.resourceObject.indexResource = index;
			this.isSidebarEditActive = true;
		},
		toggleAll() {
			this.isExpanded = !this.isExpanded;
			this.$emit("getExpanded", this.isExpanded);
			this.renderComponent += 1;
		},
		activeSidebarRepeat(item) {
			this.$emit("isSidebarRepeat", true);
			this.$emit("vehicleObjectEmit", item);
		},
		activeSidebarDetailRepeat() {
			this.$emit("isSidebarDetailRepeat", true);
		},
		getDataVehicles(val) {
			this.resourceList.forEach(([groupKey, items]) => {
				const index = items.findIndex((item) => item.identification === val.identification);
				if (index !== -1) {
					// Verificar si los datos son iguales
					const currentItem = items[index];
					if (JSON.stringify(currentItem) === JSON.stringify(val)) {
						// Los datos son iguales, no realizar ninguna acción
						return;
					}
					// Actualizar solo si los datos son diferentes
					this.$set(items, index, val);
				}
			});
		},
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}
.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 50000;
	}

	::v-deep .vs-sidebar {
		z-index: 50000;
		width: 10000px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>
<style lang="scss">
#VisitPointsItemPickup {
	.vs-collapse-item--header {
		color: rgba(var(--vs-dark), 1);
		font-weight: bold;
		font-size: 17px;
	}
}
</style>
